module.exports = "<!-- Copyright The Linux Foundation and each contributor to LFX. -->\n<!-- SPDX-License-Identifier: MIT -->\n<div class=\"d-flex\" *ngIf=\"(loadable$ | async)?.status === LOAD_FAILED\">\n    <div class=\"card shadow m-auto d-flex flex-row align-items-center bg-danger py-3 col-6 justify-content-start text-white font-weight-bold\" i18n><i class=\"mx-3 ni ni-support-16\"></i>Failed to load data.</div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/error-state/error-state.component.html
// module id = ./src/app/shared/error-state/error-state.component.html
// module chunks = main